import { FormattedMessage } from "react-intl";
import HeaderNav from "./HeaderNav";
import "../styles/Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="header-logo-wrapper">
        <img src="/img/trend/ic_logo_productsymbol_global.png" className="tball" alt="TrendMicro Logo"/>
        <span className="corp-name" >
          <FormattedMessage id="label_trend_micro" />
        </span>
        <h1 className="trend-header">
          <FormattedMessage id="label_lost_device_protection" />
        </h1>
      </div>
      <div className="header-nav">
        <HeaderNav />
      </div>
    </header>
  );
};

export default Header;
